// extracted by mini-css-extract-plugin
export default {"tile-container":"TileContainer_tile-container__JqkX5"};